import { type UserInfo } from 'interfaces';
import { isProduction } from '../constants';

interface GADataLayerEvent {
  event: string;
  label?: string;
  type?: string;
  application_id?: string | number;
  UID?: string | number;
  button_name?: string;
  stage?: string;
  field_name?: string;
  field_value?: string;
  error_text?: string;
  loan_id?: string;
  link?: string;
  registration?: string;
  error_url?: string;
}

const pushDataLayerEvent = (data: GADataLayerEvent) => {
  window.dataLayer = window.dataLayer || [];

  if (!isProduction) {
    console.log('GADataLayerEvent', data);
  } else {
    window.dataLayer.push(data);
  }
};

export const GARegisterEvent = (data: GADataLayerEvent) => {
  pushDataLayerEvent(data);
};

export const pushSendUpdEvent = () => {
  pushDataLayerEvent({ event: 'send_upd' });
};

export const GAClickButton = (label: string, user: UserInfo, stage?: string) => {
  // NOTE: to disable naming convention eslint rule for destructuring
  /* eslint-disable */
  const { registration_type, user_uuid } = user;

  GARegisterEvent({
    event: 'click_button',
    button_name: label,
    label: label,
    UID: user_uuid,
    ...(registration_type && { registration: registration_type }),
    ...(stage && { stage }),
  });
};
